<template>
  <div class="container">
    <el-tooltip effect="dark" placement="top" content="裁剪时长" :open-delay="300">
      <div
        class="btn"
        @click="goCut"
        @mouseenter="hover(true)"
        @mouseleave="hover(false)"
      >
        <i class="icon-sprite-cut-video" :class="{active: isBtnHover}"></i>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import toAnalysisParams from '@/plugins/toAnalysisParams';

export default {
  props: ['sprite'],
  data () {
    return {
      isBtnHover: false
    }
  },
  methods: {
    hover (isHover) {
      this.isBtnHover = isHover;
    },
    goCut () {
      this.$modal.show('videoSprite.cutting', {sprite: this.sprite});
      this.$analysis(toAnalysisParams('material_setting_panel,click_video_cut,素材设置面板-视频-裁剪'))
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}
.btn {
  position: absolute;
  top: -18px;
  left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/content/videoSpriteCutBtn.vue